module.exports = __webpack_public_path__ + "static/media/scanKanbanOk.2c66835c.mp3";